import { fr } from 'date-fns/locale';
import { format } from 'date-fns';

export const formatDate = date => {
  return format(new Date(date), 'dd/MM/yyyy');
};

export const formatMonth = month => {
  return format(new Date(month), 'MMMM', { locale: fr });
};

export const formatCurrency = value => {
  if (value) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  } else {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(0);
  }
};

export const formatPercentage = value => {
  return value ? `${value.toFixed(0)}%` : '0%';
};

export const getFormatter = key => {
  const formatters = {
    week: formatDate,
    month: formatMonth,
    sales: formatCurrency,
    total_carrier_price: formatCurrency,
    margin: formatCurrency,
    margin_rate: formatPercentage,
    number_of_shipments: value => value,
    total_disputes: value => value,
    retards: value => value,
    casse: value => value,
    pertes: value => value,
    manquants: value => value,
  };
  return formatters[key] || (value => value);
};

export const getTranslatedLabel = key => {
  const translations = {
    number_of_shipments: 'Nombre de dossiers',
    sales: "Chiffre d'affaires",
    total_carrier_price: 'Coût tps',
    margin: 'Marge',
    margin_rate: 'Taux de marge',
    week: 'Semaine',
    month: 'Mois',
    client: 'Client',
    client_code: 'Client',
    total_disputes: 'Total',
    retards: 'Retards',
    casses: 'Casses',
    pertes: 'Pertes',
    manquants: 'Manquants',
    client_group: 'Groupe client',
  };
  return translations[key] || key;
};
